module.exports = __webpack_public_path__ + "img/list-select.7b5d0f9f.svg";